module.exports = __webpack_public_path__ + "7be0bb8c07ee9c0b6816bbb449e4b5b8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2021-08-26/whats-new.html
// module id = 2244
// module chunks = 0